import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Service from './Service.js';

function isTouchEvent(event) {
  return typeof TouchEvent !== 'undefined' && event instanceof TouchEvent;
}

class Pointer extends Service {
  constructor() {
    super(...arguments);

    _defineProperty(this, "isDown", false);

    _defineProperty(this, "y", window.innerHeight / 2);

    _defineProperty(this, "yLast", window.innerHeight / 2);

    _defineProperty(this, "x", window.innerWidth / 2);

    _defineProperty(this, "xLast", window.innerWidth / 2);

    _defineProperty(this, "event", void 0);

    _defineProperty(this, "hasRaf", false);
  }

  init() {
    document.documentElement.addEventListener('mouseenter', this, {
      once: true,
      capture: true
    });
    var options = {
      passive: true,
      capture: true
    };
    document.addEventListener('mousemove', this, options);
    document.addEventListener('touchmove', this, options);
    document.addEventListener('mousedown', this, options);
    document.addEventListener('touchstart', this, options);
    document.addEventListener('mouseup', this, options);
    document.addEventListener('touchend', this, options);
    return this;
  }

  handleEvent(event) {
    switch (event.type) {
      case 'mouseenter':
      case 'mousemove':
      case 'touchmove':
        this.handler(event);
        break;

      case 'mousedown':
      case 'touchstart':
        this.downHandler();
        break;

      case 'mouseup':
      case 'touchend':
        this.upHandler();
        break;
    }
  }

  kill() {
    document.removeEventListener('mousemove', this);
    document.removeEventListener('touchmove', this);
    document.removeEventListener('mousedown', this);
    document.removeEventListener('touchstart', this);
    document.removeEventListener('mouseup', this);
    document.removeEventListener('touchend', this);
    return this;
  }

  handler(event) {
    this.updateValues(event);
    this.trigger(this.props);
  }

  downHandler() {
    this.isDown = true;
    this.trigger(this.props);
  }

  upHandler() {
    this.isDown = false;
    this.trigger(this.props);
  }

  updateValues(event) {
    var _event$touches$, _event$touches$2;

    this.event = event;
    this.yLast = this.y;
    this.xLast = this.x;
    var y = isTouchEvent(event) ? (_event$touches$ = event.touches[0]) === null || _event$touches$ === void 0 ? void 0 : _event$touches$.clientY : event.clientY;

    if (y !== this.y) {
      this.y = y;
    }

    var x = isTouchEvent(event) ? (_event$touches$2 = event.touches[0]) === null || _event$touches$2 === void 0 ? void 0 : _event$touches$2.clientX : event.clientX;

    if (x !== this.x) {
      this.x = x;
    }
  }

  get props() {
    return {
      event: this.event,
      isDown: this.isDown,
      x: this.x,
      y: this.y,
      changed: {
        x: this.x !== this.xLast,
        y: this.y !== this.yLast
      },
      last: {
        x: this.xLast,
        y: this.yLast
      },
      delta: {
        x: this.x - this.xLast,
        y: this.y - this.yLast
      },
      progress: {
        x: this.x / window.innerWidth,
        y: this.y / window.innerHeight
      },
      max: {
        x: window.innerWidth,
        y: window.innerHeight
      }
    };
  }

}

var pointer = null;
export default function usePointer() {
  if (!pointer) {
    pointer = new Pointer();
  }

  var add = pointer.add.bind(pointer);
  var remove = pointer.remove.bind(pointer);
  var has = pointer.has.bind(pointer);

  var props = () => pointer.props;

  return {
    add,
    remove,
    has,
    props
  };
}